import {
  Button,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  TextField,
} from "@mui/material";
import { errorMessage } from "components/AlertComponent";
import { setAction } from "context";
import { useMaterialUIController } from "context";
import { getFilesWithNationalCode } from "controllers/FileController";
import { getFilesForuser } from "controllers/FileController";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import AdapterJalali from "@date-io/date-fns-jalali";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { setFileVisible } from "controllers/FileController";
import { StoreFile } from "controllers/FileController";
import { insertPersonalPageAnswer } from "controllers/PageController";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import getText from "Translator";
import { getPatientDetails } from "controllers/FileController";
import LoadingOverlay from "react-loading-overlay";
import { updateFile } from "controllers/FileController";
import { CollectionsOutlined } from "@mui/icons-material";
let patientFromServer;

let menu;
export default function EditPatientComponent(props) {
  const [controller, dispatch] = useMaterialUIController();
  const [nationalCode, setNationalCode] = useState("");
  const [mode, setMode] = useState(0);
  const [nationalCodeList, setNationalCodeList] = useState([]);
  const [patientName, setPatientName] = useState("");
  const [patientFamily, setPatientFamily] = useState("");
  const [birthYear, setBirthYear] = useState();
  const [reload, setReload] = useState(new Date());
  const [patientExist, setPatientExist] = useState(true);
  const [focus, setFocus] = useState("nationalcode");
  const [loading, setLoading] = useState(false);
  const [patientDetails, setPatientDetails] = useState({});
  const { selectedFiles, selectedItem, closeHandle, createMenu } = props;
  const getMenu = async () => {
    menu = await localStorage.getItem("$menu");
    if (menu) {
      menu = JSON.parse(menu);
    }
  };

  const updateNewPatient = async () => {
    let savedFile;

    if (!menu) {
      await getMenu();
    }

    if (nationalCode !== "") {
      //
      if (
        nationalCode.length !== 10 ||
        !birthYear ||
        patientName.length < 3 ||
        patientFamily.length < 3 ||
        patientDetails.gender + "" == ""
      ) {
        Swal.fire({
          title: getText("warning", "fa"),
          html: getText("validatenewpatient", "fa"),
          confirmButtonText: getText("ok", "fa"),
        });
        return;
      }
    }

    let newFile = {
      file: selectedFiles[0].id,
      patientName,
      patientFamily,
      patientNationalCode: nationalCode,
      birthDate: birthYear,
    };
    savedFile = await updateFile(newFile, controller);
    if (savedFile.success) {
      let datas = [
        {
          id: "5f87e27c7d51e72a84dc57d0", //1182
          answer: patientDetails.gender,
          file: selectedFiles[0].id,
          nationalCode: nationalCode,
        },
        {
          id: "5f87e27c7d51e72a84dc5840", //1183
          answer: patientDetails.age,
          file: selectedFiles[0].id,
          nationalCode: nationalCode,
        },
        {
          id: "5f87e27c7d51e72a84dc579d", //1267
          answer: patientDetails.weight,
          file: selectedFiles[0].id,
          nationalCode: nationalCode,
        },
        {
          id: "5f87e27c7d51e72a84dc5772", //1268
          answer: patientDetails.height,
          file: selectedFiles[0].id,
          nationalCode: nationalCode,
        },
        {
          id: "5f87e27b7d51e72a84dc55a3", //1761
          answer: patientDetails.phone,
          file: selectedFiles[0].id,
          nationalCode: nationalCode,
        },
      ];
      let newData = {
        file: savedFile.data._id,
        nationalCode,
        datas,
      };
      let savedAnswers = await insertPersonalPageAnswer(newData, controller);
      console.log("savedAnswerssavedAnswers", savedAnswers);
      Swal.fire({
        text: getText("alertsuccess", "fa"),
        position: "bottom-end",
        background: "#03fca1",
        showConfirmButton: false,
        timer: 1500,
      });
      createMenu(selectedItem, "");
      closeHandle();
    } else {
      Swal.fire({
        text: savedFile.message,
        position: "bottom-end",
        background: "#f1b3af",
        showConfirmButton: false,
        timer: 2500,
      });
    }
  };

  const processNationalCode = async (text) => {
    try {
      setLoading(true);

      await getMenu();
      setNationalCode(text);
      let pData = {
        text,
        nationalCode: text,
        capsule: menu.capsule,
        birthYear,
      };
      patientFromServer = await getPatientDetails(pData, controller);
      setLoading(false);
      console.log("patientFromServer", patientFromServer);
      if (!patientFromServer.success) {
        Swal.fire({
          title: getText("warning", "fa"),
          text: getText("probleminproccess", "fa"),
          confirmButtonText: getText("ok", "fa"),
        });
        setLoading(false);

        return;
      }

      if (patientFromServer.success) {
        setPatientName(patientFromServer.data.patientName);
        setPatientFamily(patientFromServer.data.patientFamily);
        setBirthYear(patientFromServer.data.birthDate);
        setPatientDetails(patientFromServer.pg);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const convertToEnglishNumber = (str) => {
    // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });

    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  };
  useEffect(() => {
    processNationalCode(selectedFiles[0].nationalCode);
  }, []);
  return (
    <div
      style={{ padding: 10 }}
      className={"fa" === "en" ? "ltr" : "rtl"}
    >
      <Grid container style={{ marginTop: 15 }}>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          style={{
            paddingRight: "fa" === "en" ? 15 : 0,
            paddingLeft: "fa" === "fa" ? 15 : 0,
          }}
        >
          {/* <b> {getText('nationalcode', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("nationalcode", "fa")}
            key="nationalcode"
            id="nationalcode"
            value={nationalCode}
            style={{
              backgroundColor:
                nationalCode.length !== 10 ? "#ff9385" : "transparent",
            }}
            inputRef={(input) => {
              if (input != null && focus === "nationalcode") {
                input.focus();
              }
            }}
            disabled={true}
            fullWidth={true}
            variant="outlined"
            type="tel"
            maxLength={10}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          {/* <b> {getText('birthyear', "fa")}</b> */}
          {controller.dateMode === "fa" && (
            <LocalizationProvider dateAdapter={AdapterJalali}>
              <DateTimePicker
                fullWidth
                label={getText("birthdate", "fa") + "  *"}
                key="birthyear"
                id="birthyear"
                inputFormat="yyyy"
                views={["year"]}
                onChange={(value) => {
                  let nowY = moment(new Date(), "yyyy").year();
                  let birthY = moment(value, "yyyy").year();
                  console.log(nowY, birthY, nowY - birthY);
                  let temp = patientDetails;
                  temp.age = nowY - birthY;

                  setBirthYear(value);
                  setPatientDetails(temp);
                  setReload(new Date());
                  setFocus("name");
                }}
                value={birthYear}
                renderInput={(params) => <TextField {...params} disabled />}
              />
            </LocalizationProvider>
          )}
          {controller.dateMode === "en" && (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                fullWidth
                label={getText("birthdate", "fa") + "  *"}
                key="birthyear"
                id="birthyear"
                inputFormat="yyyy"
                views={["year"]}
                value={birthYear}
                onChange={(value) => {
                  let nowY = moment(new Date(), "yyyy").year();
                  let birthY = moment(value, "yyyy").year();
                  console.log(nowY, birthY, nowY - birthY);
                  let temp = patientDetails;
                  temp.age = nowY - birthY;

                  setBirthYear(value);
                  setPatientDetails(temp);
                  setReload(new Date());
                  setFocus("name");
                }}
                renderInput={(params) => <TextField {...params} disabled />}
              />
            </LocalizationProvider>
          )}
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 15 }}>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          style={{
            paddingRight: "fa" === "en" ? 15 : 0,
            paddingLeft: "fa" === "fa" ? 15 : 0,
          }}
        >
          {/* <b> {getText('name', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            style={{
              backgroundColor:
                patientName?.length < 3 && nationalCode?.length == 10
                  ? "#ff9385"
                  : "transparent",
            }}
            label={getText("name", "fa")}
            key="name"
            id="name"
            inputRef={(input) => {
              if (input != null && focus === "name") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("name");
            }}
            fullWidth={true}
            variant="outlined"
            returnKeyType="next"
            maxLength={10}
            onChange={(event) => {
              let text = event.target.value;
              setPatientName(text);
            }}
            value={patientName}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          {/* <b> {getText('family', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("family", "fa")}
            key="family"
            id="family"
            inputRef={(input) => {
              if (input != null && focus === "family") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("family");
            }}
            style={{
              backgroundColor:
                patientFamily?.length < 3 && nationalCode?.length == 10
                  ? "#ff9385"
                  : "transparent",
            }}
            fullWidth={true}
            variant="outlined"
            maxLength={10}
            onChange={(event) => {
              let text = event.target.value;
              setPatientFamily(text);
            }}
            value={patientFamily}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 15 }}>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          style={{
            paddingRight: "fa" === "en" ? 15 : 0,
            paddingLeft: "fa" === "fa" ? 15 : 0,
          }}
        >
          {/* <b> {getText('age', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("age", "fa")}
            key="age"
            id="age"
            style={{
              backgroundColor:
                patientDetails?.age + "" == "" && nationalCode?.length == 10
                  ? "#ff9385"
                  : "transparent",
            }}
            inputRef={(input) => {
              if (input != null && focus === "age") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("age");
            }}
            fullWidth={true}
            variant="outlined"
            type="tel"
            disabled={true}
            maxLength={10}
            // onChange={(event) => {
            //     let temp = patientDetails;
            //     temp.age = event.target.value;
            //     setPatientDetails(temp);
            //     setReload(new Date())
            // }}
            value={patientDetails.age}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          {/* <b> {getText('gender', "fa")}</b> */}

          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("gender", "fa")}
            key="gender"
            id="gender"
            inputRef={(input) => {
              if (input != null && focus === "gender") {
                input.focus();
              }
            }}
            style={{
              backgroundColor:
                patientDetails?.gender + "" == "" && nationalCode.length == 10
                  ? "#ff9385"
                  : "transparent",
            }}
            onFocus={() => {
              setFocus("gender");
            }}
            fullWidth={true}
            variant="outlined"
            select
            maxLength={10}
            onChange={(event) => {
              let temp = patientDetails;
              temp.gender = event.target.value;
              setPatientDetails(temp);
              setReload(new Date());
            }}
            value={patientDetails.gender + ""}
          >
            {/* <MenuItem key="0" value="61f21a2efad93874ba08084a">
                            {getText('female', "fa")}
                        </MenuItem>
                        <MenuItem key="1" value="61f21a2efad93874ba08084b">
                            {getText('male', "fa")}
                        </MenuItem> */}

            <MenuItem key="0" value="61f8d077379abf268c7c1849">
              {getText("female", "fa")}
            </MenuItem>
            <MenuItem key="1" value="61f8d077379abf268c7c184a">
              {getText("male", "fa")}
            </MenuItem>
          </TextField>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 15 }}>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          style={{
            paddingRight: "fa" === "en" ? 15 : 0,
            paddingLeft: "fa" === "fa" ? 15 : 0,
          }}
        >
          {/* <b> {getText('height', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("height", "fa")}
            key="height"
            id="height"
            inputRef={(input) => {
              if (input != null && focus === "height") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("height");
            }}
            fullWidth={true}
            variant="outlined"
            type="tel"
            maxLength={5}
            onChange={(event) => {
              let temp = patientDetails;
              temp.height = event.target.value;
              setPatientDetails(temp);
              setReload(new Date());
            }}
            value={patientDetails.height}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          {/* <b> {getText('weight', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("weight", "fa")}
            key="weight"
            id="weight"
            inputRef={(input) => {
              if (input != null && focus === "weight") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("weight");
            }}
            fullWidth={true}
            variant="outlined"
            type="tel"
            maxLength={5}
            onChange={(event) => {
              let temp = patientDetails;
              temp.weight = event.target.value;
              setPatientDetails(temp);
              setReload(new Date());
            }}
            value={patientDetails.weight}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 15 }}>
        <Grid item xs={12} sm={12} md={12}>
          {/* <b> {getText('phone', "fa")}</b> */}
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("phone", "fa")}
            key="phone"
            id="phone"
            inputRef={(input) => {
              if (input != null && focus === "phone") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("phone");
            }}
            fullWidth={true}
            variant="outlined"
            type="tel"
            maxLength={5}
            onChange={(event) => {
              let temp = patientDetails;
              temp.phone = event.target.value;
              setPatientDetails(temp);
              setReload(new Date());
            }}
            value={patientDetails.phone}
          />
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 15, flex: 1, flexDirection: "row" }}>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          <Button
            color="primary"
            onClick={() => {
              setBirthYear("");
              setNationalCode("");
              setPatientName("");
              setPatientFamily("");
              setPatientDetails({
                gender: "",
                age: "",
                weight: "",
                height: "",
                phone: "",
              });
              setPatientExist(true);

              closeHandle();
            }}
          >
            {getText("cancel", "fa")}
          </Button>
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
          }}
        ></Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={4}
          style={{
            padding: 8,
            alignItems: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          <Button
            color="primary"
            onClick={() => {
              if (controller.id.length < 10 && nationalCode.length > 0) {
                Swal.fire({
                  title: getText("warning", "fa"),
                  text: getText("firstregister", "fa"),
                  confirmButtonText: getText("ok", "fa"),
                });
                return;
              }
              updateNewPatient();
            }}
          >
            {getText("edit", "fa")}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
